export default class CabinClass {

    public static getClassName(classCode: string) {
        let className = '';
        switch (classCode) {
            case 'Y':
                className = 'Economy'
                break;
            case 'F':
                className = 'First'
                break;
            case 'C':
                className = 'Business'
                break;
            default:
                className = 'Economy'
                break;
        }

        return className;
    }
}
